import { react2angular } from 'react2angular';
import { compose } from 'redux';
import app from '../../../browser/addform/scripts/app';
import { withProvider } from '../../redux';
import { withContext } from '../../utils/hoc/withContext';
import { CadastralNumbersContainer } from './CadastralNumbers.container';

app.component(
  'cianAfCadastralNumbersSuburban',
  /**
   * TODO: вынести withContext и withProvider в один хок и поменять в других местах
   * https://jira.cian.tech/browse/CD-134895
   */
  react2angular(
    compose(withContext, withProvider)(CadastralNumbersContainer),
    [],
    ['config', 'httpApi', 'logger', 'addFormService', '$rootScope'],
  ),
);
